import { render, staticRenderFns } from "./RegulationsRegulationsGrid.vue?vue&type=template&id=1410623f&"
import script from "./RegulationsRegulationsGrid.vue?vue&type=script&lang=js&"
export * from "./RegulationsRegulationsGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsRegulationsGrid.vue?vue&type=style&index=0&id=1410623f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports